import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { cartStore } from '../../_stores/cart-store';
import { SignalWatcher } from '@lit-labs/signals';

export interface Prop {
    label: string;
    name: string;
}

@customElement('cart-summary')
export class CartSummary extends SignalWatcher(LitElement) {

    // Props

    @property({ type: Array })
    props: Prop[] = [];

    // Lifecycle Hooks

    async connectedCallback() {
        super.connectedCallback();

        // add classes
        this.classList.add('CartSummary');
    }

    // Render

    render() {
        const cartData = cartStore.data.get();
        return (cartData)
            ? html`
                <dl class="CartSummary-props">
                    ${ this.props.map((prop) => this.propTemplate(prop)) }
                </dl>`
            : '';
    }

    createRenderRoot() { 
        return this;
    }

    // Templates

    propTemplate(prop: Prop): TemplateResult {
        return html`
            <div class="CartSummary-prop CartSummary-prop">
                <dt class="CartSummary-propLabel">
                    ${ prop.label }
                </dt>
                <dt class="CartSummary-propValue">
                    <cart-prop name="${ prop.name }"></cart-prop>
                </dt>
            </div>
        `;
    }
}